<template>
  <div>
    <div  v-if="dataSource" class="obj-box">
      <div class="obj-title">
         <div class="title">
            <img v-if="dataSource.pic" :src="addip(dataSource.pic)" />
            <img v-if="dataSource.icon" :src="addip(dataSource.icon)" />
            <span class="padding-lr flex1">{{ dataSource.name }}</span>
            <a-button class="primary" @click="onAdd(dataSource.id)"><PlusOutlined /></a-button>
            <a-button class="primary" :disabled="dataSource.pic==''||dataSource.pic=='null'" @click="onLocation"><EnvironmentOutlined /></a-button>

            <a-button class="primary" @click="onEdit(dataSource.id)"><FormOutlined /> </a-button>

         </div>
         <div class="obj-quote" v-if="dataSource.children.length>0"><CaretLeftOutlined /></div>
      </div>
      <div class="obj-item">
        <div class="obj-box" v-for="(item,i) in dataSource.children" :key="i">
             <div class="obj-title">
                <div class="title">
                    <img v-if="item.pic":src="addip(item.pic)" />
                    <img v-if="item.icon" :src="addip(dataSource.icon)" />
                    <span class="padding-lr flex1">{{ item.name }}</span>
                    <a-button class="primary" @click="onAdd(item.id)"><PlusOutlined /></a-button>
                    <a-button class="primary" @click="onEdit(item.id)"><FormOutlined /> </a-button>
                    <a-button class="primary"  @click="onDel(item.id)"><CloseOutlined /></a-button>
                </div>
                <div class="obj-quote" v-if="item.children.length>0"><CaretLeftOutlined /></div>
              </div>
              <div class="obj-item">
                <div class="obj-box" v-for="(it,u) in item.children">
                    <div class="obj-title">
                      <div class="title">
                        <img v-if="it.pic":src="addip(it.pic)" />
                        <img v-if="it.icon" :src="addip(dataSource.icon)" />
                        <span class="padding-lr flex1">{{ it.name }}</span>
                        <a-button class="primary" @click="onEdit(it.id)"><FormOutlined /> </a-button>
                        <a-button class="primary"  @click="onDel(it.id)"><CloseOutlined /></a-button>
                        </div>
                    </div>
                </div>
              </div>
        </div>
      </div>
    </div>
    <sectionedit v-model:open="open" :data="model" @change="submit">
    </sectionedit>
    <imglocation ref="location" :data="dataSource" @change="locationOK"></imglocation>
  </div>
</template>
<script setup lang="ts" >
  import api from '@/utils/http/service'
  import {PlusOutlined,CloseOutlined,FormOutlined,CaretLeftOutlined,EnvironmentOutlined}  from '@ant-design/icons-vue'
  import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
  import sectionedit from './sectionedit.vue'
  import {addip} from '@/utils/util'
  import imglocation from './imglocation.vue'
  import {message}  from 'ant-design-vue'

  const location=ref()
  const dataSource=ref<Object>()
  const props= defineProps({
    id:Number
  })
  const open=ref<boolean>(false)
  const opend=ref<boolean>(false)
  const model=ref<Object>({})

  onMounted(()=>{
    getData()
  })
  const getData=()=>{
    api.section.getitems(props.id).then(res=>{
        if(res.state==1){
          dataSource.value=res.data
        }
      })
  }
  const onAdd=(pid:Number):void=>{
      var v={ID:0,title:'',sub:'',contents:'',pic:'',pid:pid,orders:1,icon:''}
      model.value=v
      open.value=true
  }
  const onDel=(tid:Number):void=>{
      api.section.del(tid).then(res=>{
        if(res.state==1){
          getData()
        }
      })
  }
  const onEdit=(tid:Number):void=>{
    api.section.get(tid).then(res=>{
      if(res.state==1){
        model.value=res.data
        open.value=true
      }
    })
  }
  const onLocation=()=>{
    if(dataSource.value.pic){

      if(dataSource.value.children.length==0) {
        message.error("使用图片定位前，请先添加至少一个子数据")
      }else{
        location.value.open()
      }
    }else{
        message.error("使用图片定位前，请先上传图片")
    }


  }
  const submit=(e:any)=>{
    api.section.add(e).then(res=>{
      if(res.state==1){
        open.value=false
      }
    })
  }
  const locationOK=(e)=>{
    if(e&&e.children){
      api.section.setxy(e.children).then(res=>{
        if(res.state==1){
          message.success(res.message)
        }
      })
    }
  }
</script>
<style >

  .obj-box{width:100%;display: flex;}
  .obj-box .obj-title{display: flex;align-items: center;
      margin:10px;
  }
  .obj-box .obj-title .title{display: flex;align-items: center;flex:1;padding:10px; box-shadow: rgba(0,0,0,.2) 0 0 24px;margin-right: 10px;}
  .obj-box .obj-title .obj-quote{height:100%;width:16px;
    border-color: rgba(200,200,200,.5);border-style: solid;border-width:0 0 0 3px;
    border-radius: 16px;display: flex;align-items: center;color:rgba(200,200,200,.5);
    font-size: 20px;margin-left: 16px;
  }
  .obj-box .obj-title .obj-quote>*{margin-left: -15px;}
  .obj-box .obj-title img{width:32px;height:32px;border-radius: 3px;margin-right: 3px;}
  .obj-box .obj-item{display: flex;flex-direction: column;align-items: flex-start;justify-content: center;}


</style>
